import { render, staticRenderFns } from "./user-identification-existing.vue?vue&type=template&id=1db568d0&scoped=true"
import script from "./user-identification-existing.vue?vue&type=script&lang=js"
export * from "./user-identification-existing.vue?vue&type=script&lang=js"
import style0 from "./user-identification-existing.vue?vue&type=style&index=0&id=1db568d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db568d0",
  null
  
)

export default component.exports